/** POST /feedback — submit a 👍/👎/general feedback row.
 *
 *  Returns { ok: true, id: <number> } on success, throws on failure.
 *  Errors are swallowed by the caller (we don't want a feedback bug to
 *  block the chat experience).  Server-side validation is strict; the
 *  client trims and clips fields here as a courtesy. */

export type Rating = "up" | "down" | "general";

interface FeedbackPayload {
  session_id: string;
  message_id?: string;
  rating: Rating;
  comment?: string;
  question?: string;
  response_text?: string;
  intent?: string;
  card_type?: string;
  pokemon_names?: string[];
}

const BASE = import.meta.env.VITE_API_BASE_URL || "";

export async function submitFeedback(payload: FeedbackPayload): Promise<{ ok: true; id: number }> {
  const body = {
    session_id: payload.session_id,
    message_id: payload.message_id,
    rating: payload.rating,
    comment: payload.comment?.slice(0, 2000)?.trim() || undefined,
    question: payload.question?.slice(0, 500)?.trim() || undefined,
    response_text: payload.response_text?.slice(0, 5000)?.trim() || undefined,
    intent: payload.intent,
    card_type: payload.card_type,
    pokemon_names: payload.pokemon_names?.slice(0, 10),
  };
  const res = await fetch(`${BASE}/feedback`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(body),
  });
  if (!res.ok) {
    throw new Error(`feedback submission failed: ${res.status}`);
  }
  return res.json();
}
